import { Button } from "@dropbox/dig-components/buttons";
import { Text } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { useOnboardingValues } from "@mirage/service-onboarding/hooks";
import { DigTooltip } from "@mirage/shared/util/DigTooltip";
import * as React from "react";

export const OnboardingDeveloperSettings: React.FC = () => {
  const { setOnboardingValue } = useOnboardingValues();

  const resetDualModeOnboarding = () => {
    setOnboardingValue("dismissedLauncherSearchTip", false);
    setOnboardingValue("dismissedLauncherTooltip", false);
    setOnboardingValue("seenFullScreenDualModeTip", false);
    setOnboardingValue("seenLauncherSearchTip", 0);
    setOnboardingValue("seenLauncherTooltipCount", 0);
  };

  return (
    <Box display="flex" alignItems="center" marginTop="8" columnGap="20">
      <Text isBold>Onboarding:</Text>
      <Box display="flex" columnGap="12">
        <DigTooltip title="Reset all onboarding values to default">
          <Button variant="filled" onClick={resetDualModeOnboarding}>
            Reset Dual Mode Onboarding
          </Button>
        </DigTooltip>
      </Box>
    </Box>
  );
};
